import {ReadinessIcon,ReadinessNavLink} from './BuildingReadiness';
import {Icon,navigationIcon} from './Icon';
import {useState} from 'react';
import {Link} from 'react-router';
import type {WorkspaceNavigation} from './area-navigation';

const storageKey='myfm-area-panel-collapsed';
function readCollapsed(){try{return localStorage.getItem(storageKey)==='true';}catch{return false;}}
function writeCollapsed(value:boolean){try{localStorage.setItem(storageKey,String(value));}catch{/* the panel still works for this page view */}}

/** Tertiary navigation for one area. It grows with the page and never scrolls on its own. */
export function AreaSidePanel({navigation}:{navigation:NonNullable<WorkspaceNavigation['tertiary']>}){
 const [collapsed,setCollapsed]=useState(readCollapsed);
 const toggle=()=>setCollapsed(value=>{writeCollapsed(!value);return !value;});
 const id='area-side-panel-links';
 return <aside className={`area-side-panel${collapsed?' is-collapsed':''}`} aria-label={`${navigation.label} pages`}>
  <div className="area-side-panel__header">
   {!collapsed&&<strong>{navigation.label}</strong>}
   <button type="button" className="area-side-panel__toggle" aria-expanded={!collapsed} aria-controls={id} onClick={toggle}
    title={collapsed?`Show ${navigation.label} menu`:`Hide ${navigation.label} menu`}>
    <Icon name={collapsed?'chevrons-right':'chevrons-left'}/><span className="sr-only">{collapsed?`Show ${navigation.label} menu`:`Hide ${navigation.label} menu`}</span>
   </button>
  </div>
  {!collapsed&&<nav id={id} aria-label={`${navigation.label} navigation`}>
   {navigation.sections.map((section,sectionIndex)=>{
    const primary=section.items.filter(item=>!['registers','review'].includes(item.id)).slice(0,8);
    const more=section.items.filter(item=>!primary.includes(item));
    const links=(items:typeof section.items)=><ul>{items.map(item=><li key={item.id}><ReadinessNavLink to={item.href} state={{buildingArea:true}} aria-current={navigation.active===item.id?'page':undefined}><ReadinessIcon name={navigationIcon(item.label)} href={item.href}/><span>{item.label}</span></ReadinessNavLink></li>)}</ul>;
    return <div key={section.label??'area-'+sectionIndex} className={`area-side-panel__group${section.label==='Review queues'?' is-queues':''}`}>
     {section.label&&<p className="area-side-panel__group-label">{section.label}</p>}
     {links(primary)}
     {more.length>0&&<details className="area-side-panel__more" open={more.some(item=>item.id===navigation.active)?true:undefined}><summary>More views</summary>{links(more)}</details>}
    </div>;
   })}
  </nav>}
 </aside>;
}
